module.exports = __webpack_public_path__ + "media/hyper/images/small/small-1-c3618961bb3a4373a135a8d1e933c95d.jpg";